import React, { forwardRef, PropsWithChildren } from 'react';
import { List } from '../../components/List';
import { ListHeader } from '../../components/ListHeader';
import { identifyComponent } from '../../util';

interface OptionGroupProps {
  compact?: React.ComponentProps<typeof List>['compact'];
  fixed?: React.ComponentProps<typeof ListHeader>['fixed'];
  hoverable?: React.ComponentProps<typeof ListHeader>['hoverable'];
  actions?: React.ComponentProps<typeof ListHeader>['actions'];
  children?: string;
}

export const OptionGroupHeader = forwardRef<HTMLLIElement, PropsWithChildren<OptionGroupProps>>(
  ({ compact, fixed = true, actions, hoverable, children }, ref) => (
    <ListHeader
      data-component="OptionGroupHeader"
      compact={compact}
      fixed={fixed}
      actions={actions}
      hoverable={hoverable}
      ref={ref}
      {...identifyComponent('option-group-header')}
    >
      {children}
    </ListHeader>
  ),
);
OptionGroupHeader.displayName = 'OptionGroupHeader';
